export default __webpack_public_path__ + "static/media/mastercard.25466163.svg";